import React from "react"
import "./XpressOn.style.css"

const addScript = (url: string, onLoad: () => void) => {
  const script = document.createElement("script")

  script.src = url
  script.async = true
  script.onload = () => {
    onLoad()
  }

  document.body.appendChild(script)
}

export const XpressOn = ({ token }: { token: string }) => {
  const [isWidgetFinished, setIsWidgetFinished] = React.useState(false)

  const showWidget = React.useCallback(() => {
    setTimeout(() => {
      addScript("https://public.pressnxpress.com/XPressOn.js", () => {
        // @ts-ignore
        XPress?.onFinished(() => {
          const widget = document.getElementById("xpressOn")

          if (widget) {
            widget.innerHTML = ""
          }

          setIsWidgetFinished(true)
        })
      })
      setIsWidgetFinished(false)

      const container = document.createElement("div")
      container.classList.add("xpressOn")
      container.setAttribute("data-prop-token", token)
      container.setAttribute("data-prop-mode", "dom")
      document.getElementById("xpressOn")?.appendChild(container)
    }, 500)
  }, [])

  React.useEffect(() => {
    const cookies = document.cookie.split(";").filter(x => x.includes("xpress"))

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf("=")
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
    }

    return () => {
      console.countReset()
    }
  }, [isWidgetFinished])

  React.useLayoutEffect(() => {
    showWidget()
  }, [showWidget])

  return (
    <div>
      {isWidgetFinished && (
        <div className="widget-finished">
          <b>Thank you for your feedback.</b>
          <button className="button" onClick={showWidget}>
            Reload
          </button>
        </div>
      )}
      <div id="xpressOn"></div>
    </div>
  )
}
